/* Package JSON Import will be here */
import { find } from "lodash";
import queryString from "query-string";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getAllMappedDistributorsApi, switchDistributor } from "services/wholesalers";
import { getErrorObject, getResObj } from "../utilities/utils";
import { updateLocalStoreWholesaler } from "./localStore";
import { showMsgFromJson, navigateToDirectLink } from "reducers/common";
import Constants from "../utilities/appConstants";
import { navigateToHome, navigateToProductList } from "app/navigation";
import { logOut } from "reducers/session";
import { categoryMenuRequest } from "reducers/categoryMenu";
import { getOrderHistory } from "reducers/orderHistory";
import { getCartDetails } from "reducers/cart";
import { getSalesReturnSummary } from "reducers/salesReturn/salesReturnSummary";
import { removeAllChangedProductFromOrderReducer } from "reducers/orders";
/* Project Import will be here */

const initialState = {
  isLoading: false,
  isLoadingSwitchDist: false,
  error: undefined,
  data: [],
  isShowDistributorSelectionModal: false
};

export const types = {
  WHOLESALERS_REQUEST: "wholesalers/WHOLESALERS_REQUEST",
  WHOLESALERS_SUCCESS: "wholesalers/WHOLESALERS_SUCCESS",
  WHOLESALERS_FAILURE: "wholesalers/WHOLESALERS_FAILURE",
  SWITCH_WHOLESALER_REQUEST: "wholesalers/SWITCH_WHOLESALER_REQUEST",
  SWITCH_WHOLESALER_RESPONSE: "wholesalers/SWITCH_WHOLESALER_RESPONSE",
  WHOLESALERS_SELECTION_SHOW: "wholesalers/WHOLESALERS_SELECTION_SHOW",
  WHOLESALERS_SELECTION_HIDE: "wholesalers/WHOLESALERS_SELECTION_HIDE"
};

export const wholesalers = (state = initialState, action) => {
  switch (action.type) {
    case types.WHOLESALERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case types.WHOLESALERS_SUCCESS: {
      return {
        ...state,
        data: action.payload.distributorList,
        isLoading: false,
        error: undefined
      };
    }

    case types.WHOLESALERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message
      };

    case types.WHOLESALERS_SELECTION_SHOW:
      return {
        ...state,
        isShowDistributorSelectionModal: true
      };

    case types.WHOLESALERS_SELECTION_HIDE:
      return {
        ...state,
        isShowDistributorSelectionModal: false
      };

    case types.SWITCH_WHOLESALER_REQUEST:
      return {
        ...state,
        isLoadingSwitchDist: true
      };

    case types.SWITCH_WHOLESALER_RESPONSE: {
      return {
        ...state,
        isLoadingSwitchDist: false
      };
    }

    default:
      return state;
  }
};

/* Get mapped and list of wholesaler */
export const getWholesalerList = (isFromLogin) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.WHOLESALERS_REQUEST });
    try {
      const response = await getAllMappedDistributorsApi();

      /* Decrypt the response obj */
      const responseObj = getResObj(response.data.Data);

      /* Get app settings config */
      const appSettings = getState().appSettings;

      /* Default dist data should exist else system will through the error */
      const defaultDist = find(responseObj, (o) => { return o.IsDefault; });
      if (defaultDist !== undefined && responseObj.length > 0) {
        const selectedDist = find(responseObj, (o) => { return o.IsSelected; });
        if (!appSettings.askDistributorSelectionOnEveryLogin && selectedDist !== undefined) {
          dispatch(updateLocalStoreWholesaler(selectedDist));

          /* Navigate the retailer the targeted location after switching to the distributor */
          if (isFromLogin)
            dispatch(navigateToHomeOrPlaceOrder());
        }
        else {
          if (responseObj.length === 1) {
            /* If the total distributor is 1 then automatically select that distributor as selected distributor */
            const needClear = selectedDist !== undefined && selectedDist.dId !== responseObj[0].dId ? true : false;
            await switchDistributor({ dId: responseObj[0].dId, ClearCart: needClear, IsFromLogin: true });
            await dispatch(updateLocalStoreWholesaler(responseObj[0]));

            /* Navigate the retailer the targeted location after switching to the distributor */
            if (isFromLogin)
              dispatch(navigateToHomeOrPlaceOrder());
          }
          else {
            dispatch({ type: types.WHOLESALERS_SELECTION_SHOW });
          }
        }
      }
      else {
        /* Show alert and redirect to login page */
        dispatch(showMsgFromJson("common.alerts.error.noDefaultDistributorMapped", Constants.ERROR));
        setTimeout(() => { dispatch(logOut()); }, 1000);
      }

      dispatch({
        type: types.WHOLESALERS_SUCCESS,
        payload: { distributorList: responseObj }
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.WHOLESALERS_FAILURE, true));
    }
  };
};


/* Select distributor after the successful login */
export const selectWholesaler = (item, isFromLogin, needClear = false, successCallback = null) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.SWITCH_WHOLESALER_REQUEST });
    try {
      /* Update selected distributor in database */
      await switchDistributor({ dId: item.dId, ClearCart: needClear, IsFromLogin: isFromLogin });

      /* Update the wholesaler in local store reducer */
      dispatch(updateLocalStoreWholesaler(item));

      dispatch({ type: types.SWITCH_WHOLESALER_RESPONSE });

      /* Navigate the retailer the targeted location after switching to the distributor */
      if (isFromLogin) {
        dispatch(navigateToHomeOrPlaceOrder());
      }
      else {
        dispatch(showMsgFromJson("wholesaler.switch.success", Constants.SUCCESS));

        dispatch(getWholesalerList(false));
        dispatch(categoryMenuRequest());
        dispatch(getOrderHistory());
        dispatch(getCartDetails());
        dispatch(getSalesReturnSummary());

        /* Remove all the products in the order reducer and re-initialize the order reducer */
        await dispatch(removeAllChangedProductFromOrderReducer(false));

        /* Distributor switch success callback */
        if (successCallback !== null)
          successCallback();
      }
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.SWITCH_WHOLESALER_RESPONSE, true));
    }
  };
}

export const closeWholesalerSelection = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.WHOLESALERS_SELECTION_HIDE });
  };
};

/* Navigate to home or place order */
export const navigateToHomeOrPlaceOrder = () => {
  return async (dispatch, getState) => {
    const query = queryString.parse(getState().router.location.search);

    if (query) {
      /* Navigate to query string landing page and focused tab */
      dispatch(navigateToDirectLink(query));
    }
    else {
      /* Navigate to home page if isLandingHomePage config is true, else navigate to product list page */
      const configSettings = getState().appSettings;
      if (configSettings.isLandingHomePage && configSettings.isEnableHomePage)
        dispatch(navigateToHome());
      else
        dispatch(navigateToProductList());
    }
  };
}

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
  return (dispatch) => {
    const { message, errorCode } = getErrorObject(error);

    /* Update the error response in the store */
    if (type !== "") {
      dispatch({
        type: type,
        payload: { error: message }
      });
    }

    /* Show error message */
    if (showToast) {
      /* If error code is exist show the error code message or show the error message returned by the API request */
      const localePath = (errorCode !== "" ? `common.alerts.error.${errorCode}` : "common.alerts.error.distributorError");
      dispatch(showMsgFromJson(localePath, Constants.ERROR));
    }
  }
};